import React from "react";
import UseContext from "hooks/useContext";
import Banner from "components/banner/banner";
import SectionWrapper from "pages/createMission/components/SectionWrapper";
import { fillText } from "pages/profil/perimeters/perimeterText";
import PerimeterSelect from "components/perimeterMissionStep/PerimeterSelect";

// "Details" step of the mission journey, reduced to the perimeter block.
const PerimeterMissionStep = ({ options, value, onChange, error }) => {
    const { language } = UseContext();
    const perimeters = options?.perimeters || [];
    const isRestricted = Boolean(options?.required);

    const description = isRestricted
        ? fillText(language.getValue("perimeters.missionStep.restrictedHelp"), {
              names: perimeters.map((perimeter) => perimeter.name).join(", "),
          })
        : language.getValue("perimeters.missionStep.help");

    return (
        <SectionWrapper
            title={language.getValue("perimeters.missionStep.title")}
            description={description}
        >
            <PerimeterSelect
                options={options}
                value={value}
                onChange={onChange}
            />
            {error && (
                <Banner type="alert" showIcon={false}>
                    {error}
                </Banner>
            )}
        </SectionWrapper>
    );
};

export default PerimeterMissionStep;
